import React from 'react'
import { IProps } from './index'
import { Text } from '../../elements/Text'
import { CTALink } from '../../elements/CTALink'
import { Image } from '../../elements/Image'
import { CTATheme, mq, fontGraphik, LegacyColor } from '../../utils'
import classnames from 'classnames'
import { NewBrandingHoc } from '../../utils/NewBrandingHoc'
import { SpotlightList as SpotlightListDefault } from './component'

function SpotlightListLegacy({ heading, listItems, leftAlign = false }: IProps) {
  const headingClassNames = classnames('spotlight-list__heading', {
    'left-aligned': leftAlign,
  })

  return (
    <div className="spotlight-list__wrapper">
      <div className="spotlight-list">
        <h2 className={headingClassNames}>
          <Text size="xxl+">{heading}</Text>
        </h2>
        <ul>
          {listItems.map((item, index) => (
            <li key={index} className="spotlight-list-item">
              <div className="spotlight-list-item__image">
                <a href={item.cta.url} target={item.cta.newWindow ? '_blank' : ''}>
                  <Image url={item.image.url} width={708} height={400} transform={'fill'} />
                  {item.videoLength && (
                    <span className="spotlight-list-item__video-duration">{item.videoLength}</span>
                  )}
                </a>
              </div>
              <div className="spotlight-list-item__copy">
                {item.eyebrow && (
                  <div className="spotlight-list-item__eyebrow">
                    <Text size="md-eyebrow">{item.eyebrow}</Text>
                  </div>
                )}
                {item.category && (
                  <div className="spotlight-list-item__category">
                    <Text size="lg-eyebrow">{item.category}</Text>
                  </div>
                )}
                <h3 className="spotlight-list-item__title">
                  <Text size="xl+">{item.title}</Text>
                </h3>
                <p className="spotlight-list-item__description">
                  <Text size="body">{item.description}</Text>
                </p>
                <CTALink {...item.cta} bgColor={CTATheme.LinkOnlyBlack} />
              </div>
            </li>
          ))}
        </ul>
      </div>
      <style jsx>{`
        .spotlight-list__wrapper {
          display: grid;
          grid-template-columns: 1fr [content] 10fr 1fr;
        }
        .spotlight-list {
          grid-area: content;
        }
        .spotlight-list__heading {
          text-align: center;
          margin-bottom: 40px;
        }
        .spotlight-list-item {
          margin-bottom: 40px;
        }
        .spotlight-list-item__image {
          margin-bottom: 16px;
        }
        .spotlight-list-item__title {
          margin-bottom: 16px;
        }
        .spotlight-list-item__description {
          margin-bottom: 16px;
        }
        .spotlight-list-item__category {
          margin-bottom: 10px;
          color: $gray-legacy;
        }
        .spotlight-list-item__eyebrow {
          color: ${LegacyColor.UIGray};
        }
        .spotlight-list-item__image {
          min-width: 200px;
          max-width: 350px;
          position: relative;
        }
        :global(.spotlight-list-item__image img) {
          border-radius: 25px;
        }
        .spotlight-list-item__video-duration {
          position: absolute;
          bottom: 10px;
          right: 0;
          background-color: black;
          color: white;
          padding: 4px;
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
          font-family: ${fontGraphik};
          font-size: 16px;
        }

        @media (${mq.tablet}) {
          .spotlight-list__wrapper {
            grid-template-columns: 2fr [content] 8fr 2fr;
          }
          .spotlight-list {
            max-width: 1000px;
            margin: 0 auto;
          }
          .spotlight-list__heading {
            max-width: 500px;
            margin: 20px auto 60px;
          }
          .leftAligned {
            text-align: left;
            margin-left: 0;
          }
          .spotlight-list-item {
            display: grid;
            grid-template-columns: [image] 2fr [copy] 4fr;

            align-items: center;
          }
          .spotlight-list-item__image {
            grid-area: image;
            max-width: unset;
          }
          .spotlight-list-item__copy {
            grid-area: copy;
            margin-left: 7vw;
            height: 100%;
          }
          .spotlight-list-item__title {
            margin-top: 0;
          }
          .spotlight-list-item__video-duration {
            right: 10px;
            padding: 4px;
            border-radius: 4px;
          }
        }

        @media (${mq.desktop}) {
          .spotlight-list-item {
            margin-bottom: 90px;
          }
          .spotlight-list-item__copy {
            margin-left: 90px;
          }
          .left-aligned {
            text-align: left;
            margin-left: 0;
          }
        }
      `}</style>
    </div>
  )
}

export const SpotlightList = NewBrandingHoc(SpotlightListLegacy, SpotlightListDefault)
